<div class="container-fluid "  style="background-color: #d0d0d0">
  <div class="container">
    <div class="row">
      <!-- Login Left -->
      <div  class="login-left align-self-center col-xl-5 col-md-6 col-xs-12">
        <h3 [innerHTML]="message"></h3>

        <!-- Form Section if token is good -->
        <form *ngIf="verifyToken == 1" [formGroup]="resetForm" (ngSubmit)="onSubmit()">
          <div class="form-group" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">

            <input id="NewPassword" type="password" formControlName="password" aria-describedby="pwRules" autocomplete="off" required class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
              <div *ngIf="f.password.errors.required">Password is required</div>
              <div *ngIf="f.password.errors.minlength">Password must be at least 8 characters</div>
            </div>
            <label for="NewPassword">New Password</label>
          </div>
          <div class="pw-rules" id="pwRules">
            <span class="pw-rules-title">Password requirements</span>
            <ul class="pw-rules-list">
              <li *ngFor="let rule of rules" [ngClass]="{ 'pw-rule-met': rule.met === true, 'pw-rule-unmet': rule.met === false }">
                <i aria-hidden="true" [ngClass]="rule.met === null ? 'far fa-circle' : (rule.met ? 'fas fa-check' : 'fas fa-times')"></i>
                <span>{{ rule.label }}<span class="sr-only" *ngIf="rule.met !== null">{{ rule.met ? ' (met)' : ' (not met)' }}</span></span>
              </li>
            </ul>
            <span class="pw-rules-note">It also cannot contain your name or email, or be one of your last 6 passwords. We check that when you submit.</span>
          </div>
          <div class="form-group" [ngClass]="{ 'is-invalid': submitted && f.confirm_password.errors }">

            <input id="ConfirmPassword" type="password" formControlName="confirm_password" autocomplete="off" required class="form-control" [ngClass]="{ 'is-invalid': submitted && f.confirm_password.errors }">
            <span class="highlight"></span>
            <span class="bar"></span>
            <div *ngIf="submitted && f.confirm_password.errors" class="invalid-feedback">
              <div *ngIf="f.confirm_password.errors.required">Confirm Password is required</div>
              <div *ngIf="f.confirm_password.errors.minlength">Password must be at least 8 characters</div>
            </div>
            <label for="ConfirmPassword">Confirm Password</label>
          </div>
          <div class="error" style="margin-bottom: 10px;" *ngIf="serverError">{{serverError}}</div>
          <button type="submit" class="btn btn-default">Submit</button>
          <a [routerLink]="['/login']">Login</a>
        </form>

        <!-- invalid token -->
        <button *ngIf="verifyToken != 1" class="btn btn-default" [routerLink]="['/login']">Back To Login</button>

      </div>

      <!-- Login Right -->
      <div class="login-right col-xl-7 col-sm-6 d-none d-md-block  " style="background-image: url('assets/images/minneapolis-skyline.jpg')">
      </div>   
  </div>
</div>
